import { HomePageConstants } from '../../_constants';

const initialState = { getCountryListLoading: true, data: '', error: false };

export function getCountryListReducer(state = initialState, action) {

    switch (action.type) {
        case HomePageConstants.REQUEST_GET_COUNTRY_LIST:
            return {
                getCountryListLoading: true,
                data: '',
                error: false
            };
        case HomePageConstants.RECEIVE_GET_COUNTRY_LIST:
            return {
                getCountryListLoading: false,
                data: action.getCountryList,
                error: false
            };
        case HomePageConstants.GET_COUNTRY_LIST_ERROR:
            return {
                getCountryListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/HomePage/getCountryList.reducer.js